import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=48dcc230&scoped=true"
import script from "./Accounts.vue?vue&type=script&lang=js"
export * from "./Accounts.vue?vue&type=script&lang=js"
import style0 from "./Accounts.vue?vue&type=style&index=0&id=48dcc230&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dcc230",
  null
  
)

export default component.exports